import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
	getConfig: async () =>
		apiCall(`${config.baseAPIUrl}/ai/config`, {
			method: 'POST',
		}),
}
